import { loadState, VARIANT_META_LOCAL_STORAGE_KEY } from './local-storage';
const toNumberOrNull = (v)=>{
    if (v == null || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
};
// Read the stored variant meta mapping from localStorage
const getVariantMeta = ()=>{
    return loadState(VARIANT_META_LOCAL_STORAGE_KEY) || {};
};
// Determine occupied box space for a variant id. Defaults to 1 when absent.
const occupiedBoxSpaceForVariant = (variantId)=>{
    const meta = getVariantMeta()[String(variantId)];
    var _meta_occupiedBoxSpace;
    const n = toNumberOrNull((_meta_occupiedBoxSpace = meta === null || meta === void 0 ? void 0 : meta.occupiedBoxSpace) !== null && _meta_occupiedBoxSpace !== void 0 ? _meta_occupiedBoxSpace : null);
    return n !== null && n !== void 0 ? n : 1;
};
// Box capacity value is supplied by the selected giftbox product variant.
// This helper computes total occupied space of a set of selected unit keys
// given the selectable units metadata (unit contains `lineKey` and `variant_id`).
const totalOccupiedSpace = (selectedUnitKeys, selectableUnits)=>{
    if (!Array.isArray(selectedUnitKeys) || selectedUnitKeys.length === 0) return 0;
    let sum = 0;
    for (const key of selectedUnitKeys){
        var _u_item, _u_item1;
        const u = selectableUnits.find((x)=>x.unitKey === key);
        if (!u) continue;
        // If unit provides an explicit `effectiveSpace`, prefer it
        if (u.effectiveSpace != null && Number.isFinite(Number(u.effectiveSpace))) {
            sum += Number(u.effectiveSpace);
            continue;
        }
        var _u_item_variant_id, _ref;
        // Otherwise lookup by variant id from stored meta
        const variantId = String((_ref = (_u_item_variant_id = (_u_item = u.item) === null || _u_item === void 0 ? void 0 : _u_item.variant_id) !== null && _u_item_variant_id !== void 0 ? _u_item_variant_id : (_u_item1 = u.item) === null || _u_item1 === void 0 ? void 0 : _u_item1.id) !== null && _ref !== void 0 ? _ref : '');
        sum += occupiedBoxSpaceForVariant(variantId);
    }
    return sum;
};
const fitsInBox = (selectedUnitKeys, selectableUnits, boxCapacity)=>{
    if (boxCapacity == null) return true;
    const total = totalOccupiedSpace(selectedUnitKeys, selectableUnits);
    return total <= boxCapacity;
};
const remainingCapacity = (selectedUnitKeys, selectableUnits, boxCapacity)=>{
    if (boxCapacity == null) return undefined;
    const total = totalOccupiedSpace(selectedUnitKeys, selectableUnits);
    return boxCapacity - total;
};
export { occupiedBoxSpaceForVariant, totalOccupiedSpace, fitsInBox, remainingCapacity };
// Resolve box capacity from giftboxProducts (variant-priority, then product)
const findBoxCapacity = (giftboxProducts, selectedHandle, selectedVariantId)=>{
    if (!selectedHandle || !giftboxProducts) return undefined;
    const product = giftboxProducts[selectedHandle];
    if (!product) return undefined;
    const key = 'boxCapacity';
    const parseVal = (v)=>{
        if (v == null || String(v).trim() === '') return null;
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    };
    if (selectedVariantId != null && Array.isArray(product.variants)) {
        const variant = product.variants.find((v)=>String(v.id) === String(selectedVariantId));
        if (variant) {
            const v = parseVal(variant.boxCapacity);
            if (v != null) return v;
        }
    }
    const prodVal = parseVal(product[key]);
    if (prodVal != null) return prodVal;
    return 2;
};
export { findBoxCapacity };
